import api from "@/api/axios.config"
import { DashboardResponseList } from "@/types/dashboard"

export const getDashboard = (emp_id: number, params?: { pes_id?: string }) => {
	return api.get<DashboardResponseList>(
		`/plataforma/dashboard?emp_id=${emp_id}`,
		{ params },
	)
}
